// extracted by mini-css-extract-plugin
export var footerStoreButtonsContainer = "Word-module--footerStoreButtonsContainer--80efb";
export var iframeYoutubeContainer = "Word-module--iframeYoutubeContainer--6fef4";
export var subtitle = "Word-module--subtitle--25a0c";
export var title = "Word-module--title--0e4cd";
export var titleSubtitleContainer = "Word-module--titleSubtitleContainer--8be58";